module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"23.8px\" height=\"18.5px\" viewBox=\"0 0 23.8 18.5\" style=\"enable-background:new 0 0 23.8 18.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><polygon class=\"st0\" points=\"23.8,2.8 20.9,0 8.1,12.9 2.8,7.6 0,10.4 8.1,18.5 \"></polygon></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/success.svg
 ** module id = 1061
 ** module chunks = 0
 **/